import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';

export default function CategoryLetterTab(props) {
  return (
          <div key={props.letter}>
          <Table
            multiselectable={false}
            key={props.letter}
            onRowSelection={(row) => props.onCategorySelected(row)}>
              <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
              enableSelectAll={false}>
                <TableRow>
                  <TableHeaderColumn style={{ width:'60px'}}>Numero</TableHeaderColumn>
                  <TableHeaderColumn>Epävirallinen nimi</TableHeaderColumn>
                  <TableHeaderColumn>Virallinen nimi</TableHeaderColumn>
                  <TableHeaderColumn>Hakutermit</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false} stripedRows={false}>
                {props.rows}
              </TableBody>
            </Table>
        </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/CategoriesPage/CategoryLetterTab.js